import { useRef } from 'react'
import { InboxOutlined } from '@ant-design/icons'

interface ImageUploaderProps {
  onUpload: (base64: string, fileName: string) => void
}

export function ImageUploader({ onUpload }: ImageUploaderProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleClick = () => {
    inputRef.current?.click()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = () => {
        const base64 = reader.result as string
        onUpload(base64, file.name)
      }
      reader.readAsDataURL(file)
    }
  }

  return (
    <div
      onClick={handleClick}
      className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-primary transition-colors"
    >
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={handleChange}
        className="hidden"
      />
      <InboxOutlined className="text-4xl text-gray-400 mb-4" />
      <p className="text-gray-600">点击或拖拽图片到此处上传</p>
      <p className="text-gray-400 text-sm">支持 JPG、PNG、GIF 格式</p>
    </div>
  )
}
